import { render, staticRenderFns } from "./PopitGame.vue?vue&type=template&id=c930be88&scoped=true&"
import script from "./PopitGame.vue?vue&type=script&lang=js&"
export * from "./PopitGame.vue?vue&type=script&lang=js&"
import style0 from "./PopitGame.vue?vue&type=style&index=0&id=c930be88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c930be88",
  null
  
)

export default component.exports